"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperienceTable = void 0;
const ui_1 = require("@app/component/ui");
const data_grid_1 = require("@app/component/ui/data-grid");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const ExperienceTable = ({ control, setEdited }) => {
    const { fields, update } = (0, react_hook_form_1.useFieldArray)({ control, name: 'employeeExperience' });
    return (react_1.default.createElement(data_grid_1.DataGrid, { columns: [
            {
                cells: [
                    {
                        label: (0, util_1.t)('POSITIONS'),
                        value: (0, util_1.t)('EMPLOYEE_PROFILE_CARD_CONTRACT_SKILL'),
                    },
                    ...fields.map((field) => ({
                        label: react_1.default.createElement(ui_1.Position, { key: 'quick_pos_' + field.position, pos: field }),
                        value: (react_1.default.createElement(ui_1.SkillSelect, { size: 'full-width', value: field?.skill ?? 'any', onChange: (val) => {
                                update(fields.findIndex((f) => f.position === field.position), { ...field, skill: val });
                                setEdited(field?.position);
                            }, includeAny: false })),
                    })),
                ],
            },
        ] }));
};
exports.ExperienceTable = ExperienceTable;
